import React from 'react';
import {
    BringzzPageContainer,
    BringzzButton,
    BringzzIcon,
    BringzzImage,
    BringzzText
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useOrder } from 'context/OrderContext';

const PrescriptionPage = () => {
    const { backPress, navigate } = useNavigation();
    const { orderDetails, prescriptionInfo } = useOrder();

    return (
        <BringzzPageContainer
            className="h-full flex flex-col"
            header={{
                left: <BringzzIcon
                    size="18"
                    icon="IconClose"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: "Verify Prescription"
            }}

            footer={
                <div className="flex justify-center p-4 gap-4">
                    <div className="w-1/2">
                        <BringzzButton
                            size="lg"
                            className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                            onClick={() => navigate('/prescription/valid', { state: { value: "uuid" } })}
                        >
                            {"Valid"}
                        </BringzzButton>
                    </div>
                    <div className="w-1/2">
                        <BringzzButton
                            size="lg"
                            className="bg-red-500 w-full flex justify-center text-white"
                            onClick={() => navigate('/prescription/invalid')}
                        >
                            {"Invalid"}
                        </BringzzButton>
                    </div>
                </div>
            }
            footerHover={true}
        >
            <div className="flex flex-col items-center h-full pt-12">
                {/* Get prescription image from orderDetails or prescriptionInfo */}
                {(orderDetails?.prescription?.photo || prescriptionInfo?.prescriptionImageUrl || prescriptionInfo?.photo) ? (
                    <BringzzImage
                        src={orderDetails?.prescription?.photo || prescriptionInfo?.prescriptionImageUrl || prescriptionInfo?.photo}
                        alt="Prescription"
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="flex flex-col items-center justify-center h-full px-4">
                        <BringzzIcon
                            icon="IconImage"
                            folder="LineIcons"
                            size="48"
                            className="text-gray-400 mb-4"
                        />
                        <BringzzText tag="h3" className="text-gray-600 text-center">
                            No prescription image available
                        </BringzzText>
                        <BringzzText tag="h4" className="text-gray-500 text-center mt-2">
                            Please upload a prescription to continue
                        </BringzzText>
                    </div>
                )}
            </div>
        </BringzzPageContainer>
    );
};

export default PrescriptionPage;
